const textKPI1 = `<h1>KPI for Project Managers</h1>

KPI for project managers is made up of the total cost of projects that need to be completed in one particular month. For the purposes of this policy, the total number of projects that need to be completed will be indicated by the term KPI.

KPI is set for each specific position in accordance with the company's internal document: “Career in BUSINESS BOUTIQUE DMCC”.

To calculate the total cost of completed projects, only the net fees of BUSINESS BOUTIQUE DMCC excluding VAT are taken into account. Administrative fees are not taken into account when calculating the total amount of completed projects, since these funds are used to cover administrative costs for customer service: repair and maintenance of corporate cars, taxi rides, customer service in the office (tea, coffee, chocolate, etc.) , corporate telephony and more.

When calculating the total amount of completed projects, the cost of some projects can be taken into account in full, while the cost of a number of other projects can be taken into account only partially.

Also, if the work on the project is carried out simultaneously by several project managers, or the PRO is also involved in the project, the cost of the projects is distributed among the participants according to the KPI Table - ver. 1.5, and in exceptional cases according to the agreement between them.

<b>All 100% of the cost of projects</b> can be taken into account when working on the following tasks:
<ol>
    <li>company registration,</li>
    <li>registration of a resident visa of any category,</li>
    <li>opening a personal account,</li>
    <li>opening a corporate account,</li>
    <li>services given on an hourly basis,</li>
    <li>making changes to the corporate structure,</li>
    <li>execution of a power of attorney,</li>
    <li>support with the search for an apartment, office for rent (initial request),</li>
    <li>extension of the validity of resident visas,</li>
    <li>updating the client's KYC at the bank,</li>
    <li>legalization of documents,</li>
    <li>accounting support and support in the preparation of the audit report.</li>
</ol>
The following projects are assessed <b>differently</b>:
<ol>
    <li>extension of the license validity period (from 15% to 35%),</li>
    <li>extension of the client's apartment or office lease (50%),</li>
    <li>execution of lease agreements for the purpose of opening bank accounts (50%).</li>
</ol>
<b>1) extension of the license validity period (from 15% to 35%)</b>

When calculating the cost of a project for KPI purposes, not the entire project is taken into account, but only its part (%). The project manager has the right to include a part (percentage) of the cost of this project in accordance with the table below, provided that he has already worked in the company for 6 months and has successfully passed the trial period:

<h2>Extension of licenses and submission of docs to the bank</h2>
`
const textKPI12 = `

15% - If authorities issue all updated documents electronically and do not require travel, and work can be  carried out remotely.

20% - Authorities requiring annual audits and where physical filing or receipt of documents is required.

35% - a company in the Dubai Free Zone with a requirement to extend the lease of a physical office and undergo an annual audit.

* + 5% can be added to the project cost when the shareholders are legal entities, and this leads to the need to coordinate, obtain and legalize the documents of the parent company in the UAE.

** + 5% can be added to the project cost if a NOC (non-objection certificate) is required from external authorities.

However, if assistance with legalization and obtaining a NOC is charged separately and is not included in the cost of the extension project, the inclusion of an additional 5% in the cost of the extension project is not acceptable.

Number of license extension projects:
<ul>
    <li>cannot be more than fifteen (15) per month in the first year of employment (from 6 to 12 months of work in BB),</li>
    <li>no more than ten (10) per month in the first year of operation, and</li>
    <li>no more than five (5) in the second and third years of work,</li>
    <li>from the fourth year of work in BB, the project manager cannot take into account the cost of projects for license extension when calculating the total amount of completed projects on a monthly basis.</li>
</ul>
The cost of a license extension project is not included in statistics in the following cases:
<ul>
    <li>The customer did not receive the following set of reminders:</li>
</ul>1 month before the license expires and 2 weeks before the license expires,
<ul>
    <li>If a client is subject to penalties as a result of ineffective work of a member of the Business Boutique team:</li>
</ul>The company's license was untimely extended, which entailed fines (the exception is those cases when the client was repeatedly warned about such fines)

The license was extended, but the establishment card was not extended in time, resulting in penalties for the client

<b>2) extension of the license validity period (from 15% to 35%)</b>

<h2>Extension of the client's apartment lease</h2>
`
const textKPI13 = `

The cost of a project to extend the lease of an apartment is not included in the statistics in the following cases:
<ul>
    <li>The client did not receive the following set of reminders:</li>
</ul>3.5 months before the expiration of the rental period for the apartment and 1 month before the expiration of the rental period for the apartment,

if the client is subject to penalties as a result of the ineffective work of a member of the Business Boutique team and the renewal was not carried out in a timely manner (the exception is those cases when the client was repeatedly warned about such penalties),

if, after 3.5 months' notice, the client announced that he did not plan to extend the lease, and BB did not notify the lessor on its behalf, for which the client would need to pay a fine.

<b>3) Execution of lease agreements for the purpose of opening bank accounts (50%)</b>

<h2>EXECUTION OF LEASE AGREEMENTS FOR THE BANK</h2>
`
const textKPI2 = `

<h1>WHEN A PROJECT IS CONSIDERED COMPLETED</h1>

The project is considered fully completed and it can be included in the calculation of the total amount of completed projects in the following cases:

<h2>Status description</h2>
`
const textKPI3 = `

<h1>REDUCED PROJECT COST</h1>

The cost of a completed project can only be partially included:

<b>- minus 50%</b> of the project cost - <b>Company registration</b> - The documents that are stored in the office in the original and the print sketch are not uploaded to the client card, and the entire list of received statutory documents is not indicated in the History Tab (marked “electronic copy” or “original ”). Company card not created. Client status has not been transferred from Prospective to Active in the management system.

<b>- minus 5%</b> of the project cost - <b>Issuing a power of attorney</b> - There is no entry in the card indicating the power of attorney number, validity period and from whom and to whom it was issued.

<b>- minus 20%</b> of the project cost - <b>Opening a personal account</b> - Information about the account number, bank was not entered and information was not added to the History Tab about the difficulties encountered in the opening process, the availability of credit cards was not indicated.

<b>- minus 40%</b> of the project cost - <b>Opening a corporate account</b> - Information about the account number, bank has not been entered and information has not been added to the History Tab about the difficulties encountered in the opening process, the balance is not indicated and whether there are investment products, credit cards.

<b>- minus 50%</b> of the project cost - <b>Amendments to the corporate structure</b> - All information about changes (changes in the structure, company name, types of activities, additional licenses) is not included in the company card - History Tab. Changed the suffix in the company name (if required).

<b>- minus 30%</b> of the project cost - <b>Registration of a resident visa AND Extension of the validity of a resident visa</b> - No entry has been made in the card with information on visa, increase or decrease of the visa quota.

<b>- minus 20%</b> of the project cost - <b>Support with finding an apartment, office for rent (initial request)</b> - All information is entered in the card.

<b>- minus 40%</b> of the project cost - <b>Updating the client's KYC in the bank</b> - There is no entry in the History Tab about what information has been updated, files are not saved on the server in the Bank >>> KYC Update folder.

<b>- minus 30%</b> of the project cost - <b>Legalization of documents</b> - There is no note in history about which country and which documents were legalized.

<b>- minus 30%</b> of the project cost - <b>Support in the preparation of the audit report</b> - There is no entry in the company's card about who did the audit and whether we helped in this matter.

<b>- minus 50%</b> of the project cost - <b>Extension of company registration</b> - Company card has not been updated.

<b>- minus 50%</b> of the project cost - <b>Renewal of the client's apartment lease agreement</b> - The information in the client's card has not been updated.

<b>- minus 50%</b> of the project cost - <b>Execution of a lease agreement for bank purposes</b> - The client's card does not contain a record of the address and the lessor, and also does not store information about who helped in this matter and the contacts of this person.

<b>- minus 50%</b> of the project cost - <b>Liquidation of the company</b> - In the management system, the status of the company has not been changed to Liquidated. The History Tab also does not indicate the reason for the cancellation of the visa.

<b>- minus 50%</b> of the project cost - <b>Cancellation of a resident visa</b> - No entry has been made on the client's card about visa cancellation. The History Tab also does not indicate the reason for the cancellation of the visa.

<b>- minus 50%</b> of the project cost - <b>Closing a personal / corporate account</b> - The History Tab does not indicate the reason for closing the account, on what conditions and who helped to close it.

<b>- minus 50%</b> of the project cost - <b>Registration of a SIM card</b> - An entry is made in the History Tab about the phone number, type of card, to whom it is issued, on what conditions and for how long the renewal is planned.

What you must add to the History Tab:

<i>1) a brief description of all conflict situations with the client, the cause of the situation, and how it was resolved:</i>

For example, an entry regarding the client Alexander Kondratyuk:

Client was working with BB on multiple projects, was happy with the service but at some point, decided to discontinue relationship. During conversation with client it was relayed to BB's management, that BB's team member initially presented to client breakdown of Sham's fees without discount from Shams. Client learned from Shams directly that they had discounts for renewal, which was not reflected in BB's invoice, and felt drastic lack of transparency in BB's fees. As a result, client switched to a different service provider. BB lost a client.

BB's Management conducted a phone call with client, understood the problem, explained that fees were correctly communicated in the first email (with discount from SHAMS). In the second email, however, BB Team member forgot to reflect SHAMS’ discounted license renewal fee (in the second email client asked to include visa assistance fee in the proposal for license renewal). As a result, client focused on the second email with incorrect SHAMS license renewal fees, communicated by mistake. It was clarified to client that BB follows very strict transparency policy and the second email was sent in error. There was a number of services offered to client and at the end he decided to come back to BB.

<i>2) customer feedback on working with BB,</i>

<i>3) the wishes of clients and their plans (if they share such), for example, about plans to move to the UAE, arrange children in school, buy real estate,</i>

<i>4) comments regarding those clients who decided not to renew and left the company.</i>
`
const textKPI4 = `

<h1>IF THE CLIENT HAS BEEN FINEED BY BB</h1>

If the Client has been charged with fines through the fault of the BB Project Manager, the Client has paid the fines, the cost of the entire project is not taken into account when summing up all completed projects.

If the Client has been charged with fines through the fault of the BB Project Manager, the fines were required to be covered by BB from its own funds, the cost of the entire project is not taken into account when summing up all completed projects. In addition, the amount of the fine is deducted from the salary of the project manager.

If the Client, through the fault of the BB Project Manager, was charged with fines, but the Project Manager made every effort and achieved an extremely positive feedback from the client on this particular project, and the fines were covered by the Client, the cost of the entire project is taken into account when adding up all completed projects.

We are confident that you can find a common language with any Client. Therefore, if the Client receives complaints more than two times about working with the Project Manager, the cost of current projects for this Client is not taken into account, unless the Project Manager reaches an understanding with the Client and receives positive feedback from him before the end of the project.

At BB, it is extremely important for us to be correct and very diplomatic when dealing with clients. Direct requests from Clients to give a good assessment of the work of the Project Manager is unacceptable. In the event that the information “The project manager has asked for a good rating / recommendation” is brought to the attention of the BB management, administrative action will be taken against such a project manager.
`
const textKPI5 = `

<h1>POSITIVE FEEDBACK ON PROJECTS</h1>

If the Project Manager receives an extremely positive feedback from the client (written or oral - to the company's management) regarding the implementation of a project, the Project Manager can claim + 10% of the project cost when calculating the total amount of completed projects.
`
const textKPI6 = `

<h1>IMPLEMENTING KPI</h1>

In order to qualify for the payment, the Project Manager must achieve the KPI assigned to him for at least 3 consecutive months. That is, if the delivered KPI = 62,000 dirhams, the payment is made subject to the following scenario:

December - 62,000 dirhams
January - 62,000 dirhams
February - 70,000 dirhams = due payment for overfulfillment of the plan, since in the two previous months the KPI was achieved.

If the KPI was not reached only in the previous month, and in the current one there is an excess of the KPI, the amount of overfulfillment should compensate for the previous month. The payout in this case must be calculated from the difference:

Ex. KPI = 62,000 dirhams
Completed projects in December - for 60,000 dirhams
Projects completed in January - for 82,000 dirhams
In this case, 2,000 dirhams (62,000 - 60,000) will compensate for the unreached KPI in the last month, and at the rate of 80,000 dirhams, the amount payable will be calculated ((80,000 - 62,000) * 20% = 3,600 dirhams payable

If the KPI has not been reached in the previous two months, and in the current one there is an excess of the KPI, the amount of overfulfillment must first compensate for both previous months, and in the next month, in case of overfulfillment, a payment is due. The payout in this case must be calculated from the difference:

Ex. KPI = 62,000 dirhams
Completed projects in December - for 60,000 dirhams
Completed projects in January - for 50,000 dirhams
Projects completed in February - for 82,000 dirhams

In this case, 14,000 dirhams will compensate for the unreached KPI last month, and at the rate of 68,000 dirhams, the amount payable will be calculated ((68,000 - 62,000) * 15% = 1,200 dirhams payable.
`
const textKPI7 = `

<h1>PAYMENTS</h1>

Payment is made on the 22nd, 23rd or 24th of the month on the day of payment of wages for the previous month based on projects closed last month.

For payout, the BB 2021 Targets - Bonuses table must be completed by the 21st of the month in relation to projects closed in the previous month. Each project must have a closing date. If, due to imprudence, a project was not added to the table before the 21st, it is not taken into account when calculating the total amount to be paid.


`

export default {textKPI1, textKPI12, textKPI13, textKPI2, textKPI3, textKPI4, textKPI5, textKPI6, textKPI7}



// WEBPACK FOOTER //
// ./src/constants/kpiInfo/en.js